import React from 'react';

import { ModalTypes, useModal } from 'models/modal';

import Modal from 'components/atoms/Modal';
import Button from 'components/atoms/Button';

import Gift from 'images/icon/sign-up-gift.inline.svg';

import styles from './index.module.css';

const SignUpGiftModal: React.FC = () => {
	const [, { closeModal }] = useModal();

	return (
		<Modal
			type={ModalTypes.SignUpGiftModal}
			className={{ modal: styles.modal, wrapper: styles.wrapper }}
		>
			<Gift />
			<h2>註冊成功</h2>
			<p>註冊禮已發送至您的帳戶</p>
			<p>請登入後至「我的優惠券」中查詢</p>

			<Button name="確認" handleClick={() => closeModal()} className={styles.btn} />
		</Modal>
	);
};

export default SignUpGiftModal;
